import { Loader } from '@grafikr/components';

import {
  getSelectedRegionFromUrl,
  SELECTED_REGION_QUERY_PARAM,
  SELECTED_REGION_STORAGE_KEY,
} from 'utils/get-selected-region';
import getUserRegion from 'utils/get-user-region';
import { NonNullish } from 'utils/nullish-check';

export const HAS_SELECTED_STORAGE_KEY = 'snt:geo:has-chosen-site';
export const HAS_SELECTED_DESTINATION_STORAGE_KEY = 'snt:geo:has-selected-destination';

export default Loader(async (_, load) => {
  const url = new URL(window.location.href);
  const selectedRegionCode = getSelectedRegionFromUrl(url);
  const hasSelectedRegionParam = url.searchParams.has(SELECTED_REGION_QUERY_PARAM);
  const isRedirected = url.searchParams.has('redirected');
  const shouldCleanUrl = hasSelectedRegionParam || isRedirected;

  if (selectedRegionCode) {
    localStorage.setItem(HAS_SELECTED_DESTINATION_STORAGE_KEY, 'true');
    localStorage.setItem(SELECTED_REGION_STORAGE_KEY, selectedRegionCode);
  } else if (hasSelectedRegionParam) {
    localStorage.removeItem(HAS_SELECTED_DESTINATION_STORAGE_KEY);
    localStorage.removeItem(SELECTED_REGION_STORAGE_KEY);
  }

  if (shouldCleanUrl) {
    url.searchParams.delete(SELECTED_REGION_QUERY_PARAM);
    url.searchParams.delete('redirected');

    window.history.replaceState(
      window.history.state,
      '',
      `${url.pathname}${url.search}${url.hash}`,
    );
  }

  if (isRedirected) {
    localStorage.setItem(HAS_SELECTED_STORAGE_KEY, 'true');

    if (selectedRegionCode) {
      localStorage.setItem(HAS_SELECTED_DESTINATION_STORAGE_KEY, 'true');
    } else {
      localStorage.removeItem(HAS_SELECTED_DESTINATION_STORAGE_KEY);
      localStorage.removeItem(SELECTED_REGION_STORAGE_KEY);
    }

    return;
  }

  if (localStorage.getItem(HAS_SELECTED_STORAGE_KEY)) {
    return;
  }

  if (!document.querySelector('link[rel="alternate"][hreflang]')) {
    // If no links are available, return early
    return;
  }

  const language = NonNullish(navigator.language.split('-').at(0));
  const region = await getUserRegion();

  const selectors = [
    `link[rel="alternate"][hreflang="${language}-${region}"]`,
    `link[rel="alternate"][hreflang$="-${region}"]`,
    `link[rel="alternate"][hreflang^="${language}-"]`,
  ];

  let link: HTMLLinkElement | null = null;
  for (const selector of selectors) {
    link = document.querySelector<HTMLLinkElement>(selector);

    if (link) {
      break;
    }
  }

  if (link) {
    const currentUrl =
      document.querySelector<HTMLLinkElement>('link[rel="canonical"]')?.href ??
      `${window.location.origin}${window.location.pathname}`;

    if (currentUrl !== link.href) {
      load();
    }
  } else {
    load();
  }
});
